import React, { useState, useMemo  } from "react";
import axios from "axios";
import { FiSave } from "react-icons/fi";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Editor } from "@tinymce/tinymce-react";
import useUserLanguage from "../../hooks/useUserLanguage";
import useTranslations from "../../hooks/useTranslations";

function getImageDimensions(file) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const url = URL.createObjectURL(file);
    img.onload = () => {
      resolve({ width: img.width, height: img.height });
      URL.revokeObjectURL(url);
    };
    img.onerror = reject;
    img.src = url;
  });
}

export default function MailTemplatesCreate() {
  const [templateData, setTemplateData] = useState({
    title: "",
    content: "",
    status: "active",
  });

  const language = useUserLanguage();
  const { translations } = useTranslations(language);

  // getText fonksiyonu (useMemo ile optimize)
  const getText = useMemo(() => {
    return (key, defaultValue = "") => translations[key] || defaultValue;
  }, [translations]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setTemplateData((prev) => ({ ...prev, [name]: value }));
  };

  const handleEditorChange = (content) => {
    setTemplateData((prev) => ({ ...prev, content }));
  };

  const saveTemplate = async () => {
    if (!templateData.title.trim() || !templateData.content.trim()) {
      toast.warn(getText("WARNING_REQUIRED_FIELDS"));
      return;
    }
    try {
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/mail-templates`, templateData);
      toast.success(getText("SUCCESS_TEMPLATE_SAVED"));
    } catch (error) {
      console.error("Şablon eklenemedi:", error);
      toast.error(getText("ERROR_TEMPLATE_NOT_ADDED"));
    }
  };

  return (
    <div className="container mt-4">
  <ToastContainer />
  <div className="card card-body lead-info mb-4">
    <h3 className="fw-bold text-primary mb-3">{getText("CREATE_TEMPLATE_TITLE")}</h3>

    {/* Başlık */}
    <div className="mb-3">
      <label className="form-label fw-bold">{getText("TEMPLATE_TITLE_LABEL")}</label>
      <input
        type="text"
        name="title"
        className="form-control"
        value={templateData.title}
        onChange={handleChange}
        onKeyDown={(e) => e.key === "Enter" && e.preventDefault()}
        placeholder={getText("PLACEHOLDER_TEMPLATE_TITLE")}
      />
    </div>

    {/* İçerik (TinyMCE) */}
    <div className="mb-3">
      <label className="form-label fw-bold">{getText("TEMPLATE_CONTENT_LABEL")}</label>
            <Editor
        tinymceScriptSrc="https://cdnjs.cloudflare.com/ajax/libs/tinymce/7.6.1/tinymce.min.js"
        value={templateData.content}
        onEditorChange={handleEditorChange}
        init={{
          promotion: false,
          height: 500,
          
          plugins: [
            "advlist", "autolink", "link", "image", "lists", "charmap",
            "preview", "anchor", "pagebreak", "searchreplace", "wordcount",
            "visualblocks", "code", "fullscreen", "insertdatetime", "media",
            "table", "emoticons", "help"
          ],
          toolbar:
            "undo redo | styles | bold italic | alignleft aligncenter alignright alignjustify | " +
            "bullist numlist outdent indent | link image | " +
            "print preview media fullscreen code | forecolor backcolor emoticons | help",
          content_style: "body { font-family:Helvetica,Arial,sans-serif; font-size:16px }",
          image_advtab: true,
          automatic_uploads: true, 
          images_upload_url: `${process.env.REACT_APP_API_BASE_URL}/api/mail-templates/upload`,
          images_upload_handler: null, 
        }}
      />


    </div>

    {/* Kaydet Butonu */}
    <div className="text-center">
    <button 
  className="btn btn-primary" 
  type="button"
  onClick={(e) => { 
    e.preventDefault(); 
    saveTemplate();
  }}
>
  <FiSave /> {getText("SAVE_BTN")}
</button>
    </div>
  </div>
</div>

  );
}
